import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { useWatch } from 'react-hook-form';
import { isOmissisEnabled } from '../../directives/omissis/OmissisDirective.type.tsx';
import { ButtonsLayout } from './components/ButtonsLayout.tsx';
import { UploadWidgetComponentInput } from './components/UploadWidgetComponentInput.tsx';
import { type IUploadWidget, UploadButtonsLayout } from './IUploadWidget.ts';
import { publicDataUploadWidgetName } from './UploadWidget.type.tsx';

export type IUploadWidgetComponentProps = IWidgetComponentProps<IUploadWidget>;

/**
 * Per la gestione dell'upload in caso di omissis abilitato, dobbiamo
 * comunque passare lo **Stesso** id sia per il campo privato che per
 * il campo pubblico, al backend.
 */
function useAttachmentUniqueId(props: IUploadWidgetComponentProps) {
  const options = getWidgetProps(props);
  const privateIdFieldName = options.name;
  const publicIdFieldName = publicDataUploadWidgetName(options.name);
  const [privateId, publicId] = useWatch({
    name: [privateIdFieldName, publicIdFieldName],
  });
  return privateId ?? publicId;
}

export function UploadWidgetComponent(props: IUploadWidgetComponentProps) {
  const publicUpload = isOmissisEnabled(props.widget);

  const attachmentUniqueId = useAttachmentUniqueId(props);

  return (
    <ButtonsLayout
      hasOmissis={publicUpload}
      horizontal={
        props.widget.layout?.buttonLayout == UploadButtonsLayout.Horizontal
      }
    >
      <UploadWidgetComponentInput
        {...props}
        attachmentUniqueId={attachmentUniqueId}
      />
      {publicUpload && (
        <UploadWidgetComponentInput
          {...props}
          publicUpload
          attachmentUniqueId={attachmentUniqueId}
        />
      )}
    </ButtonsLayout>
  );
}
